(function ($) {
    $.fn.tip = function (options) {
        var settings = $.extend(
            {
                id: '',
                on: 'click',
                offset: [],
                offsetX: '',
                offsetY: '',
                onBeforeShow: '',
                onBeforeHide: '',
            },
            options,
        );

        return this.each(function () {
            if (settings.offset.length == 0) {
                settings.offset[0] = 30;
                settings.offset[1] = $(this).outerWidth() / 2 - $(settings.id).outerWidth() / 2;
            }

            $(this).bind(settings.on, function (e) {
                e.stopPropagation();

                $(settings.id)
                    .find('.box-arrow-up')
                    .css('left', $(settings.id).outerWidth() / 2 - 7);
                $(settings.id)
                    .css('top', settings.offset[0])
                    .css('left', settings.offset[1])
                    .toggle();

                if (settings.offsetY != '') {
                    $(settings.id).css('top', settings.offsetY);
                }
                if (settings.offsetX != '') {
                    $(settings.id).css('left', settings.offsetX);
                }
                if (typeof settings.onBeforeShow == 'function') {
                    settings.onBeforeShow();
                }
            });

            $(settings.id)
                .find('.close')
                .bind('click', function (e) {
                    e.stopPropagation();
                    if (typeof settings.onBeforeHide == 'function') {
                        settings.onBeforeHide();
                    }
                    $(settings.id).hide();
                });
        });
    };

    $.fn.showHeaderMenu = function (options) {
        var settings = $.extend(
            {
                id: '',
                offset: [],
                onBeforeShow: '',
                onBeforeHide: '',
            },
            options,
        );

        return this.each(function () {
            $(this).hover(
                function () {
                    if (typeof settings.onBeforeShow == 'function') {
                        settings.onBeforeShow();
                    }
                    $(settings.id).show();
                },
                function () {
                    if (typeof settings.onBeforeHide == 'function') {
                        settings.onBeforeHide();
                    }
                    $(settings.id).hide();
                },
            );
        });
    };

    $.fn.fixImages = function (options) {
        var settings = $.extend(
            {
                fallback: '/assets/mobile/images/site/490x268_VideoThumbs_Generic.jpg',
            },
            options,
        );

        var __fix = function (obj) {
            $(obj).attr('src', settings.fallback);
            if (typeof settings.css == 'object') {
                $(obj).css(settings.css);
            }
        };

        return this.each(function () {
            var img = $(this).find('img');
            img.on('error', function () {
                __fix(this);
            });
            if (img.attr('src') == '') {
                __fix(img);
            }
        });
    };

    $.fn.mask = function (options) {
        var settings = {
                bgColor: '#000',
                className: 'cbs-ui-mask',
                opacity: '0.7',
                zIndex: 500001,
            },
            w = '100%',
            h = $(document).height();
        settings = $.extend(settings, options);

        var self = this;

        this.show = function () {
            if ($('.' + settings.className).length == 0) {
                self.append('<div class="' + settings.className + '" />');
                $('.' + settings.className)
                    .css('top', 0)
                    .css('left', 0)
                    .css('width', w)
                    .css('height', h)
                    .css('z-index', settings.zIndex)
                    .css('display', 'block')
                    .css('position', 'absolute')
                    .css('opacity', settings.opacity)
                    .css('background-color', settings.bgColor);
            }
            return self;
        };

        this.hide = function () {
            $('.' + settings.className).remove();
            return self;
        };
        return this;
    };

    $.fn.cbsOverlay = function (options) {
        var settings = {
            maskClassName: 'cbs-ui-mask',
            target: '',
            closeTargetClassName: 'close',
            onClose: '',
            tracking: {
                onView: '',
                onClickCloseIcon: '',
                otherEvents: '',
            },
        };
        settings = $.extend(settings, options);

        var self = this,
            mask = $('body').mask({
                className: settings.maskClassName,
            });

        this.invoke = function (callback, val) {
            if (callback != null || callback != '') {
                try {
                    if (typeof callback == 'string') {
                        window[callback](val);
                    }
                    if (typeof callback == 'function') {
                        callback(val);
                    }
                } catch (e) {
                    console.log('UI.cbsOverlay.invoke: ' + e.message);
                }
            }
        };

        this.hide = function (el) {
            $(self).hide();
            mask.hide();
            self.invoke(settings.onClose, el);
            return self;
        };

        this.tracking = {
            onView: function () {
                self.invoke(settings.tracking.onView);
            },
            otherEvents: function () {
                self.invoke(settings.tracking.otherEvents);
            },
        };

        return this.each(function () {
            mask.show();

            $(this)
                .css('position', 'fixed')
                .css('top', '250px')
                .css('left', '50%')
                .css('right', '0')
                .css('bottom', '0')
                .css('transform', 'translate(-50%,-20%)')
                .css('msTransform', 'translate(-50%,-20%)')
                .css('zIndex', 500100);

            self.tracking.onView();

            $(self)
                .find('.' + settings.closeTargetClassName)
                .each(function () {
                    $(this).click(function () {
                        self.hide($(this));
                    });
                });
        });
    };

    // Adapters for old jquery tools functions
    $.fn.overlay = function (options) {
        $(this).cbsOverlay();
        if (typeof options.onLoad === 'function') {
            options.onLoad();
        }
        return {
            load: function () {},
        };
    };

    $.fn.scrollable = function () {
        $(this).slick({
            variableWidth: true,
            prevArrow: '<a class="carousel-prev focusable"></a>',
            nextArrow: '<a class="carousel-next focusable"></a>',
        });
    };
})(jQuery);
